import React, { useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { createAggridColumn } from "@icarius-table/utils";
import RatingRenderer from "@icarius-table/renderersAndFilters/ratingRenderer";
import IndicatorRenderer from "@icarius-table/renderersAndFilters/indicatorRenderer";
import RichTextRenderer from "@icarius-table/renderersAndFilters/richTextRenderer";
import NineBoxImageRenderer from "@icarius-table/renderersAndFilters/nineBoxImageRenderer";
import ProgressRenderer from "@icarius-table/renderersAndFilters/progressRenderer";
import ProgressFilter from "@icarius-table/renderersAndFilters/progressFilter";
import AgGridContainer from "@icarius-common/commonPage/agGridContainer";

const frameworkComponents = {
  RatingRenderer,
  IndicatorRenderer,
  RichTextRenderer,
  NineBoxImageRenderer,
  ProgressRenderer,
  ProgressFilter,
};

const TestResultsSection = ({ filters, result, isTesting }) => {

  const gridRef = useRef(null);
  const wasTestingRef = useRef(false);

  useEffect(() => {
    const gridApi = gridRef.current?.api;

    if (gridApi) {
      if (isTesting) {
        gridApi.showLoadingOverlay();
      } else if (wasTestingRef.current) {
        gridApi.hideOverlay();
      }
    }

    wasTestingRef.current = isTesting;
  }, [isTesting]);

  const createColumnDefs = () => {
    const columnDefs = [];

    for (let field in filters) {
      if (Object.prototype.hasOwnProperty.call(filters, field)) {
        columnDefs.push(createAggridColumn(field, filters[field]));
      }
    }

    return columnDefs;
  };

  return (
    <Grid container item xs={12} style={{ padding: "8px 10px", marginTop: 24 }}>
      <Grid item xs={12}>
        <h3 style={{ margin: 0, marginBottom: 10, color: "var(--mainText)", fontWeight: "normal", fontSize: "1rem" }}>
          {getLocalizedString("testQueryResults")}
        </h3>
      </Grid>
      <Grid item xs={12}>
        <AgGridContainer
          ref={gridRef}
          ownColumnDef={createColumnDefs()}
          rowData={result || []}
          gridTitle={getLocalizedString("testQueryResults")}
          height={300}
          hasFixedFilters={false}
          frameworkComponents={frameworkComponents}
        />
      </Grid>
    </Grid>
  );
};

export default TestResultsSection;
